module.exports = __webpack_public_path__ + "static/media/reception.3de88236.jpg";